import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Card, CardContent } from '@/modules/ui/components/card/Card';
import Container from '@/modules/ui/components/container/Container';
import { PageHeader } from '@/modules/ui/components/page-header/PageHeader';
import {
  UserForm,
  type UserFormValues,
} from '@/modules/users/components/UserForm';
import { useCreateUserMutation } from '@/modules/users/mutations/useCreateUserMutation';
import { extractErrorMessage } from '@/utils/extractErrorMessage';

const UserAdd = () => {
  const navigate = useNavigate();
  const createUserMutation = useCreateUserMutation();

  const handleSubmit = async (values: UserFormValues) => {
    createUserMutation.mutate(values, {
      onSuccess: () => {
        toast.success(`User ${values.email} has been added`);
        navigate('/users');
      },
      onError: (error) => {
        toast.error(
          `User ${values.email} has not been added: ${extractErrorMessage(error)}`,
        );
      },
    });
  };

  return (
    <Container>
      <PageHeader
        title="Create User"
        subtitle="Enter the user's email address. They will be able to sign in using their Google account."
      />
      <Card>
        <CardContent>
          <UserForm
            mode="create"
            submitText="Create User"
            isPending={createUserMutation.isPending}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/users')}
          />
        </CardContent>
      </Card>
    </Container>
  );
};

export default UserAdd;
